module.exports = __webpack_public_path__ + "static/media/PILLS.158c0ff3.png";